import i18n from 'i18next'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { apiRoutes } from './app/modules/shared/routing'
import { languageStorage } from './app/modules/auth/helper/storage'

// Saved on every change (both switcher modes), so a reload starts in the picked language
i18n.on('languageChanged', (language) => languageStorage.saveLanguage(language))

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .init({
    backend: {
      loadPath: apiRoutes.translation,
    },
    react: {
      useSuspense: false,
    },
    lng: languageStorage.getLanguage() ?? 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
